import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // ✅ import Autoplay
import "swiper/css";
import "swiper/css/pagination";
import dummy from "../../assets/images/dummy.png";
const ReviewSlider = ({ reviews }) => {
  return (
    <Swiper
      modules={[Pagination, Autoplay]} // ✅ add Autoplay here
      pagination={{ clickable: true }}
      loop={reviews?.length > 1 ? true : false}
      autoHeight={true}
      autoplay={{
        delay: 5000, // ✅ time between slides (ms)
        disableOnInteraction: false, // ✅ keeps autoplay after user swipes
      }}
      className="rounded-2xl  overflow-hidden h-full review"
    >
      {reviews
        ?.filter((slide) => slide.status === "1")
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((slide, index) => (
          <SwiperSlide key={index} className="pb-12">
            <div className="bg-secondary flex flex-col justify-between h-full py-12 2xl:py-20 px-10 rounded-2xl mx-auto ">
              {/* Message */}
              {slide.message && (
                <p className="text-white text-4xl md:text-4xl 2xl:text-5xl text-center leading-snug mb-4">
                  “{slide.message}”
                </p>
              )}

              {/* Bottom: Name + Image */}
              <div className="flex items-center justify-center gap-4 mt-4 lg:mt-10 mb-0   mx-auto">
                <div className="w-[50px] h-[50px] rounded-full overflow-hidden border-2 border-white flex-shrink-0 shadow">
                  <img
                    src={
                      slide.image
                        ? process.env.REACT_APP_BACKEND_URL +
                          "public/" +
                          slide.image
                        : dummy
                    }
                    alt={slide.name}
                    className="w-full h-full max-w-[50px] object-cover bg-gray"
                  />
                </div>

                <div>
                  <p className="text-orange text-lg md:text-xl">{slide.name}</p>
                  {/* <p className="text-orange font-mono text-sm md:text-md">
                    {slide.email}
                  </p> */}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export default ReviewSlider;
